import React, { useState } from 'react'

import { Tabs, Tab, useTheme } from '@material-ui/core'

import { Container, TabPanel } from '../../../components'
import { TokensTab } from './TokensTab'
import { ProvidersTab } from './ProvidersTab'
import { PoolTab } from './PoolTab'
import { LeasingSeasonConfigAdminTab } from './LeasingSeasonConfigAdminTab'
import { useOutreach } from '../../../hooks/Outreach/useOutreach'
import { ProviderBillingMode } from '../../../models/Outreach/types'

const POOL_TAB = 0
const TOKENS_TAB = 1
const PROVIDERS_TAB = 2
const LEASING_SEASON_CONFIG_TAB = 3

export const OutreachHome = () => {
    const theme = useTheme()
    const [selectedTab, setSelectedTab] = useState<number>(POOL_TAB)

    const {
        providers,
        isLoadingProviders,
        createProvider,
        updateProvider,
        deleteProvider,
    } = useOutreach({ loadProviders: true })

    const handleUpdateProvider = async (
        id: number,
        provider: {
            name: string
            credit_cost: number
            billing_mode: ProviderBillingMode
        },
    ) => {
        await updateProvider.mutateAsync({
            id,
            updates: provider,
        })
    }

    const handleCreateProvider = async (providerData: {
        name: string
        credit_cost: number
        billing_mode: ProviderBillingMode
    }) => {
        await createProvider.mutateAsync(providerData)
    }

    const handleDeleteProvider = async (id: number) => {
        await deleteProvider.mutateAsync(id)
    }

    const TabPanelStyle: React.CSSProperties = {
        backgroundColor: theme.palette.grey[200],
        flex: 1,
    }

    return (
        <Container style={{ flex: 1, flexDirection: 'column' }} scrollY>
            <Tabs
                value={selectedTab}
                onChange={(_, newValue) => setSelectedTab(newValue)}
                style={{ backgroundColor: theme.palette.grey[300] }}
            >
                <Tab label="Pool" value={POOL_TAB} />
                <Tab label="Tokens" value={TOKENS_TAB} />
                <Tab label="Providers" value={PROVIDERS_TAB} />
                <Tab
                    label="Leasing Season Config"
                    value={LEASING_SEASON_CONFIG_TAB}
                />
            </Tabs>

            <TabPanel
                value={POOL_TAB}
                index={selectedTab}
                style={TabPanelStyle}
            >
                <PoolTab />
            </TabPanel>

            <TabPanel
                value={TOKENS_TAB}
                index={selectedTab}
                style={TabPanelStyle}
            >
                <TokensTab />
            </TabPanel>

            <TabPanel
                value={PROVIDERS_TAB}
                index={selectedTab}
                style={TabPanelStyle}
            >
                <ProvidersTab
                    providers={providers || []}
                    isLoading={isLoadingProviders}
                    onUpdateProvider={handleUpdateProvider}
                    onCreateProvider={handleCreateProvider}
                    onDeleteProvider={handleDeleteProvider}
                />
            </TabPanel>

            <TabPanel
                value={LEASING_SEASON_CONFIG_TAB}
                index={selectedTab}
                style={TabPanelStyle}
            >
                <LeasingSeasonConfigAdminTab />
            </TabPanel>
        </Container>
    )
}
